import { Card } from "@/components/ui";
import { useAppDispatch, useAppSelector } from "@/config/store";
import { ChatState, getUserParticipationByChat, setSelectedParticipation } from "@/shared/reducers/chat.reducer";
import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";

const ChatDetailRoutes = () => {
    const dispatch = useAppDispatch();
    const params = useParams<{ id: string }>();
    const { selectedParticipation } = useAppSelector<ChatState>(state => state.chat);

    useEffect(() => {
        return () => {
            dispatch(setSelectedParticipation(null));
        };
    }, []);

    useEffect(() => {
        if (params.id && (selectedParticipation === null || selectedParticipation?.id !== Number(params.id))) {
            dispatch(getUserParticipationByChat(params.id));
        }
    }, [params.id]);


    return (
        <div className="px-4 py-6 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-3xl">
                <Card className="surface flex h-[calc(100vh-160px)] flex-col overflow-hidden p-0">
                    <Outlet />
                </Card>
            </div>
        </div>
    );
};

export default ChatDetailRoutes;
